import * as requestFromServer from './userDetailsCrud';
import {userDetailsSlice, callTypes} from './userDetailsSlice';
import mime from 'mime-types';
import moment from 'moment';
import {downloadFile, logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {subjects as S} from '../../_common/constants/subjects';
import {logMessages as L} from '../../_common/constants/logMessages';

const {actions} = userDetailsSlice;

export const fetchUser = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.user}));

  return requestFromServer
    .getUser(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;

      if (errorCode !== 0) throw new Error();
      dispatch(actions.userFetched({
        user: data
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find user!';
      dispatch(actions.catchError({error, callType: callTypes.user}));
    });
};

export const getFile = ({id, name, extension}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getFile(id)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      const fileName = `${name}.${extension}`;
      const contentType = mime.lookup(extension);

      try {
        downloadFile(`data:${contentType};base64,${data}`, fileName, contentType);
      } catch (exc) {
        console.error('Save Blob method failed with the following exception.');
        console.error(exc);
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const editUserData = ({userID, paramName, paramValue, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .editUserData({userID, paramName, paramValue})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_INFORMATION,
        T.EDIT,
        L.USER_EDIT_DATA(paramName, paramValue, email),
        errorCode
      );
      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t edit data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const generate6101 = ({userID, selfEmployedEndDate, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .generate6101({userID, selfEmployedEndDate})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_FILE,
        T.CREATE,
        L.USER_GENERATE_6101(email, selfEmployedEndDate ? moment(selfEmployedEndDate).format('DD-MM-YYYY') : ''),
        errorCode,
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t edit data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const generate6101New = ({userID, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .generate6101New({userID})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_FILE,
        T.CREATE,
        L.USER_GENERATE_6101_NEW(email),
        errorCode,
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t edit data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const uploadForm101 = ({userMongoId, file, form101, year, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  const fileType = file.name.endsWith('jpg') ? 'jpg' : mime.extension(file.type);
  const formData = new FormData();
  formData.set('userMongoID', userMongoId);
  formData.set('fileName', file.name);
  formData.set('fileExtension', fileType);
  formData.set('content', file);
  formData.set('form101', form101);
  formData.set('year', year);

  return requestFromServer
    .uploadFiles({formData})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_FILE,
        T.UPLOAD,
        L.USER_UPLOAD_FORM_101(email),
        errorCode,
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t upload file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const uploadFile = ({userMongoId, file, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  const fileType = file.name.endsWith('jpg') ? 'jpg' : mime.extension(file.type);
  const formData = new FormData();
  formData.set('userMongoID', userMongoId);
  formData.set('fileName', file.name);
  formData.set('fileExtension', fileType);
  formData.set('content', file);

  return requestFromServer
    .uploadFiles({formData})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_FILE,
        T.UPLOAD,
        L.USER_UPLOAD_FILE(file?.name, email),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t upload file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const uploadFileTaxAdjustment = ({userMongoId, file, taxAdjustment, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  const fileType = file.name.endsWith('jpg') ? 'jpg' : mime.extension(file.type);
  const formData = new FormData();
  formData.set('userMongoID', userMongoId);
  formData.set('fileName', file.name);
  formData.set('fileExtension', fileType);
  formData.set('content', file);
  formData.set('taxAdjustment', taxAdjustment);

  return requestFromServer
    .uploadFiles({formData})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_FILE,
        T.UPLOAD,
        L.USER_UPLOAD_FILE_TAX_ADJUSTMENT(file?.name, email),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t upload file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const listFileVersions = ({uniqueId}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .listFileVersions({uniqueId})
    .then(response => {
      const {data} = response.data;
      return data;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t list versions!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const deleteFile = ({userMongoID, fileName, fileMongoID, email}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .deleteFile({userMongoID, fileName, fileMongoID})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_FILE,
        T.DELETE,
        L.USER_DELETE_FILE(fileName, email),
        errorCode
      );
      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'can\'t upload file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getUsersDDList = (name) => (dispatch) => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getUsersDDList(name)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const setInvitedUser = (invitedUserID, userID, invitedUserName, username, date) => (dispatch) => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .setInvitedUser(invitedUserID, userID, date)
    .then(response => {
      const {errorCode, data} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_INFORMATION,
        T.EDIT,
        L.USER_SET_INVITED_USER(invitedUserName, username, moment(date).format('DD-MM-YYYY')),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
      return data;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t set data';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const disableUser = (userID, email) => (dispatch) => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .disableUser(userID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_INFORMATION,
        T.EDIT,
        L.USER_DISABLE(email),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t disable user';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const enableUser = (userID, email) => (dispatch) => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .enableUser(userID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.USER_DETAILS,
        S.USER_INFORMATION,
        T.EDIT,
        L.USER_ENABLE(email),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t enable user';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getUserAdditionalDataHistory = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.user}));

  return requestFromServer
    .getUserAdditionalDataHistory(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;

      if (errorCode !== 0) throw new Error();
      dispatch(actions.userDataHistoryFetched({
        userDataHistory: data
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find user data history!';
      dispatch(actions.catchError({error, callType: callTypes.user}));
    });
};